

























import { Component, Prop, PropSync } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { defaultSystemCode, SystemCode } from '@/api'
import DataTable from '@/components/molecules/DataTable/DataTable.vue'
import { CODE_KEY } from '@/config'
import { Col } from '@/components/molecules/DataTable'
import { systemCodeStore } from '@/utils/store-accessor'

export interface UsageStatisticsReferenceTableItem {
  referenceType: SystemCode
  inputs: UsageStatisticsReferenceTableItemInput[]
}

interface UsageStatisticsReferenceTableItemInput {
  userType: SystemCode
  counter: {
    input: string
  }
}

const defaultUsageStatisticsReferenceTableItemInput = (): any => ({
  userType: defaultSystemCode(),
  counter: {
    input: '0'
  }
})

@Component({
  components: { DataTable }
})
export default class UsageStatisticsReferenceTable extends ComponentVue {
  @PropSync('inputs', {
    type: Array,
    required: true
  })
  inputItems!: UsageStatisticsReferenceTableItem[]

  @Prop({
    type: Number,
    required: true
  })
  height!: number

  get numberMask(): string {
    return '#'.repeat(5)
  }

  get inputTargetObject(): any {
    return (tableRow: UsageStatisticsReferenceTableItem, code: string) => {
      return (
        tableRow.inputs.find(input => input.userType.code === code) ??
        defaultUsageStatisticsReferenceTableItemInput()
      )
    }
  }

  get cols(): Col[] {
    if (this.statisticsUserTypeSystemCodes.length === 0) {
      return []
    }

    const width: number = Math.round(
      100 / (this.statisticsUserTypeSystemCodes.length + 1)
    )

    return [
      {
        width: String(100 - width * this.statisticsUserTypeSystemCodes.length),
        resizable: true,
        items: [
          {
            name: 'referenceType',
            headerText: '区分'
          }
        ]
      },
      ...this.statisticsUserTypeSystemCodes.map(systemCode => {
        return {
          width: String(width),
          resizable: true,
          items: [
            {
              name: systemCode.code,
              headerText: systemCode.shortName
            }
          ]
        }
      })
    ]
  }

  get statisticsUserTypeSystemCodes(): SystemCode[] {
    return systemCodeStore.filterByCodeKey(CODE_KEY.STATISTICS_USER_TYPE.KEY)
  }
}
